module.exports = __webpack_public_path__ + "img/1554355155.613496f6.jpg";